
/** Take a typeOf format (percent or delta) with two values and return a formatted value */
export const formatValueToPercentOrDelta = (typeOfFormat, displayedValue, referencedValue) => {

  if(!typeOfFormat || !displayedValue || !referencedValue) return 0

  if(typeOfFormat === "percent"){
    let tempPercentage = displayedValue / referencedValue
    return (tempPercentage - 1) * 100
  }

  if(typeOfFormat === "delta"){
    return displayedValue - referencedValue
  }

  return 0
}